'use strict';

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _union = require('lodash/union');

var _union2 = _interopRequireDefault(_union);

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _Grid = require('lemon-ui/lib/collections/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    'default': obj
  };
}

function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return Array.from(arr);
  }
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var responsiveContainerOptionsDefault = {
  isMultiline: true,
  isCentered: true,
  isGapless: true,
  hasWrapper: true,
  responsive: 'isMobile'
};

exports['default'] = function () {
  var responsiveOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var defaultResponsiveMapping = arguments[1];
  var responsiveContainerOptions = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : responsiveContainerOptionsDefault;
  var isResponsive = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  var hasResponsiveContainer = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : true;
  return function (WrappedComponent) {
    var defaultProps = _extends({}, WrappedComponent.defaultProps, {
      isResponsive: WrappedComponent.defaultProps.isResponsive || isResponsive,
      hasResponsiveContainer: WrappedComponent.defaultProps.hasResponsiveContainer || hasResponsiveContainer,
      responsiveOptions: WrappedComponent.defaultProps.responsiveOptions || responsiveOptions,
      responsiveContainerOptions: WrappedComponent.defaultProps.responsiveContainerOptions || responsiveContainerOptions,
      responsiveMapping: WrappedComponent.defaultProps.responsiveMapping || defaultResponsiveMapping
    });

    var Responsive = function (_Component) {
      _inherits(Responsive, _Component);

      function Responsive(props) {
        _classCallCheck(this, Responsive);

        return _possibleConstructorReturn(this, (Responsive.__proto__ || Object.getPrototypeOf(Responsive)).call(this, props));
      }

      _createClass(Responsive, [{
        key: 'render',
        value: function render() {
          var _props = this.props,
              isResponsive = _props.isResponsive,
              hasResponsiveContainer = _props.hasResponsiveContainer,
              responsiveOptions = _props.responsiveOptions,
              responsiveContainerOptions = _props.responsiveContainerOptions,
              responsiveMapping = _props.responsiveMapping,
              innerRef = _props.innerRef,
              additionalStyles = _props.additionalStyles,
              props = _objectWithoutProperties(_props, ['isResponsive', 'hasResponsiveContainer', 'responsiveOptions', 'responsiveContainerOptions', 'responsiveMapping', 'innerRef', 'additionalStyles']);

          var wrappedComponent = _react2['default'].createElement(WrappedComponent, _extends({}, props, {
            isResponsive: isResponsive,
            ref: innerRef
          }));

          var element = wrappedComponent;

          if (isResponsive) {
            // const mergedResponsiveOptions = merge( {},
            //     defaultProps.responsiveOptions,
            //     responsiveOptions
            // );
            // const mergedResponsiveContainerOptions = merge( {},
            //     defaultProps.responsiveContainerOptions,
            //     responsiveContainerOptions
            // );
            var size = responsiveOptions.size,
                offset = responsiveOptions.offset;
            var mappedSize = size;
            var hasResponsiveMapping = !!responsiveMapping;

            if (hasResponsiveMapping) {
              var mapping = responsiveMapping;

              if (mapping && !mapping.length) {
                mapping = defaultResponsiveMapping;
              }

              mappedSize = mapping.map(function (entry) {
                var propValue = (0, _get2['default'])(props, entry.path);
                var value = entry.map[propValue];

                if (Array.isArray(value)) {
                  return value;
                }

                return [value];
              });
              mappedSize = _union2['default'].apply(undefined, _toConsumableArray(mappedSize));
            }

            var insideGrid = _react2['default'].createElement(_Grid2['default'].Column, {
              size: mappedSize,
              offset: offset,
              style: _extends({
                maxWidth: '100vw'
              }, additionalStyles)
            }, wrappedComponent);

            element = insideGrid;

            if (hasResponsiveContainer) {
              var style = {}; // only from boxed components
              //

              if (props.boxed && props.box && props.box.bgColor) {
                style.backgroundColor = props.box.bgColor;
              }

              element = _react2['default'].createElement(_Grid2['default'].Columns, _extends({}, responsiveContainerOptions, {
                style: style,
                className: 'responsive'
              }), insideGrid);
            }
          }

          return element;
        }
      }]);

      return Responsive;
    }(_react.Component);

    Responsive.displayName = 'Responsive' + WrappedComponent.displayName;
    Responsive.propTypes = _extends({}, WrappedComponent.propTypes, {
      isResponsive: _propTypes2['default'].bool,
      hasResponsiveContainer: _propTypes2['default'].bool,
      additionalStyles: _propTypes2['default'].object,
      responsiveOptions: _propTypes2['default'].shape({
        size: _Grid2['default'].Column.propTypes.size,
        offset: _Grid2['default'].Column.propTypes.offset
      }),
      responsiveContainerOptions: _propTypes2['default'].shape({
        responsive: _Grid2['default'].Columns.propTypes.responsive,
        isGapless: _Grid2['default'].Columns.propTypes.isGapless,
        isMultiline: _Grid2['default'].Columns.propTypes.isMultiline,
        isVcentered: _Grid2['default'].Columns.propTypes.isVcentered,
        isCentered: _Grid2['default'].Columns.propTypes.isCentered
      }),
      responsiveMapping: _propTypes2['default'].arrayOf(_propTypes2['default'].shape({
        path: _propTypes2['default'].string,
        map: _propTypes2['default'].object
      }))
    });
    Responsive.defaultProps = defaultProps;
    return (0, _hoistNonReactStatics2['default'])(Responsive, WrappedComponent);
  };
};